import { Category } from "../models/Category";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_CATEGORIES = "UPDATE_CATEGORIES";

export interface GetCategories {
  type: typeof GET_CATEGORIES;
  payload: Array<Category> | undefined;
}

export interface UpdateCategories {
  type: typeof UPDATE_CATEGORIES;
  payload: Category;
}

interface UpdateCategoryAction {
  type: typeof UPDATE_CATEGORY;
  payload: Category;
}

export type CategoryActions =
  | GetCategories
  | UpdateCategories
  | UpdateCategoryAction;


